import { UrlService } from './url.service';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PdfModel } from '../models/pdf.model';
import { map } from 'rxjs';
import { TokenService } from './token.service';
import {
  LOADER_OPTS,
  SKIP_GLOBAL_LOADER,
} from '../core/interceptors/loader.tokens';

@Injectable({
  providedIn: 'root',
})
export class WelodgeService {
  private http = inject(HttpClient);
  private tokenService = inject(TokenService);
  private urlService = inject(UrlService);


  login(username: string, password: string) {
    // console.log('Login attempt with username:', username, 'and password:', password); // REMOVED FOR SECURITY

    const url = this.urlService.getUrl() + '/ws/Settings/SettingsArea.ashx';
    const body = {
      typeHandler: 'Login',
    };
    const headers = {
      Authorization: 'Basic ' + btoa(`${username}:${password}`),
    };

    return this.http.post(url, body, { headers });
  }

  getTagList(templateId: number) {
    const base = this.urlService.getUrl();
    const url = `${base}/ws/Documents/DocumentsArea.ashx`;

    const body = {
      typeHandler: 'getTagList',
      Token: this.tokenService.getToken()!,
      TemplateId: templateId,
    };

    const headers = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(
          `${this.tokenService.getCredentials().username}:${
            this.tokenService.getCredentials().password
          }`
        ),
    });
    const context = new HttpContext().set(LOADER_OPTS, {
      label: 'Caricamento Template...',
    });

    return this.http.post(url, body, { headers, context });
  }

  getModel(templateId: number) {
    const base = this.urlService.getUrl();
    const url = `${base}/ws/Documents/DocumentsArea.ashx`;

    const body = {
      typeHandler: 'getModel',
      Token: this.tokenService.getToken()!,
      Id: templateId,
    };

    const headers = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(
          `${this.tokenService.getCredentials().username}:${
            this.tokenService.getCredentials().password
          }`
        ),
    });
    const context = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
    return this.http.post(url, body, { headers, context });
  }

  getDocumentBodyTemplatesId() {
    const base = this.urlService.getUrl();
    const url = `${base}/ws/Documents/DocumentsArea.ashx`;

    const body = {
      typeHandler: 'getDocumentBodyTemplateTypeId',
      Token: this.tokenService.getToken()!,
    };

    const headers = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(
          `${this.tokenService.getCredentials().username}:${
            this.tokenService.getCredentials().password
          }`
        ),
    });
    const context = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
    return this.http.post(url, body, { headers, context });
  }

  getPdfModels(
    buId: number,
    bgId?: number[],
    typeId?: number | null | undefined,
    context?: HttpContext
  ) {
    const base = this.urlService.getUrl();
    const url = `${base}/ws/Documents/DocumentsArea.ashx`;
    const body = {
      typeHandler: 'getModelsList',
      Token: this.tokenService.getToken()!,
      TemplateType: 1,
      State: 3,
      TypeId: typeId,
      // CategoryId : catId,
      BusinessGroups: bgId,
      BusinessUnitId: buId,
    };

    const headers = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(
          `${this.tokenService.getCredentials().username}:${
            this.tokenService.getCredentials().password
          }`
        ),
    });

    return this.http.post(url, body, { headers, context });
  }

  getBusinessGroups(buId: number, context?: HttpContext) {
    const base = this.urlService.getUrl();
    const url = `${base}/ws/Documents/DocumentsArea.ashx`;

    const body = {
      typeHandler: 'getBusinessGroupId',
      Token: this.tokenService.getToken()!,
      BusinessUnitId: buId,
    };

    const headers = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(
          `${this.tokenService.getCredentials().username}:${
            this.tokenService.getCredentials().password
          }`
        ),
    });

    return this.http.post(url, body, { headers, context });
  }

  createPdf(templateId: number, metadata: []) {
    const base = this.urlService.getUrl();
    const url = `${base}/ws/Documents/DocumentsArea.ashx`;

    const body: PdfModel = {
      typeHandler: 'createPDFModels',
      Token: this.tokenService.getToken()!,
      TemplateId: templateId,
      TemplateType: 1,
      Metadata: { ...metadata },
      AttachMetadata: true,
    };

    const headers = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(
          `${this.tokenService.getCredentials().username}:${
            this.tokenService.getCredentials().password
          }`
        ),
    });
    const context = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
    return this.http.post(url, body, { headers, context });
  }

  getDocCategories() {
    const body = {
      typeHandler: 'getDocumentCategoryId',
      Token: this.tokenService.getToken()!,
    };

    const base = this.urlService.getUrl();
    const url = `${base}/ws/Documents/DocumentsArea.ashx`;

    const headers = new HttpHeaders({
      Authorization:
        'Basic ' +
        btoa(
          `${this.tokenService.getCredentials().username}:${
            this.tokenService.getCredentials().password
          }`
        ),
    });
    const context = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
    return this.http.post(url, body, { headers, context });
  }
}
